import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { UtilsService } from 'app/services/utils.service';
import { PdfViewerModule } from 'ng2-pdf-viewer';

@Component({
  selector: 'app-pdf-viewer',
  templateUrl: './pdf-viewer.component.html',
  styleUrls: ['./pdf-viewer.component.scss'],
  standalone: true,
  imports: [IonicModule, CommonModule, TranslateModule, PdfViewerModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PdfViewerComponent implements OnInit {
  @Input() state;
  pdfSrc = '';
  state$: unknown;
  showPDF: boolean;
  fileName: unknown;
  constructor(
    public activatedRoute: ActivatedRoute,
    public modalCtrl: ModalController,
    private readonly utilService: UtilsService,
  ) {}

  public async ngOnInit() {
    this.showPDF = false;
    this.state$ = this.state;
    if (this.state$) {
      await this.utilService.showLoading();
      this.pdfSrc = this.state$ as string;
      this.fileName = this.extractFileName(this.pdfSrc);
      this.showPDF = true;
      this.utilService.hideLoading();
    }
  }

  private extractFileName(path: string): string {
    const lastSlashIndex = path.lastIndexOf('/');

    return path.substring(lastSlashIndex + 1);
  }

  public goBack() {
    this.modalCtrl.dismiss({
      dismissed: true,
    });
  }
}

